import axios from 'axios'
import { USER_ONBOARDING_STATUS } from '../utils/constants'
import { EDVR_ENDPOINTS } from '../utils/constants/endpoints'
import {
    AUTHENTICATED_USER,
    AUTH_TOKEN,
    GUEST_USER,
    ROUTES,
} from '../utils/constants/enum'
import { Axios } from './axios'

const config = {
    baseURL: process.env.REACT_APP_MWH_ENDEAVOR_API_URL
        ? process.env.REACT_APP_MWH_ENDEAVOR_API_URL
        : '',
}

const axiosInstance = axios.create(config)

axiosInstance.interceptors.request.use(function (config) {
    const token = localStorage.getItem(AUTH_TOKEN.ENDEAVOR_AUTH_TOKEN)
    const authToken = token && JSON.parse(token)
    if (config?.headers) {
        config.headers.Authorization = authToken
            ? `Bearer ${authToken?.authorisationToken}`
            : ''
        config.headers.realm = process.env.REACT_APP_MWH_ENDEAVOR_REALM_KEY
            ? process.env.REACT_APP_MWH_ENDEAVOR_REALM_KEY
            : ''
        config.headers['x-api-key'] = process.env
            .REACT_APP_MWH_ENDEAVOR_X_API_KEY
            ? process.env.REACT_APP_MWH_ENDEAVOR_X_API_KEY
            : ''
        return config
    }
})

axiosInstance.interceptors.response.use(
    (res) => {
        return res
    },
    async (err) => {
        const originalConfig = err.config
        if (err.response) {
            if (err?.response?.status === 401) {
                const refreshToken = localStorage.getItem(
                    AUTH_TOKEN.ENDEAVOR_AUTH_TOKEN
                )
                const authToken = refreshToken && JSON.parse(refreshToken)
                if (authToken?.refreshToken) {
                    try {
                        const tokenResponse = await axiosInstance.post(
                            EDVR_ENDPOINTS.REFRESH_TOKEN,
                            {
                                refreshToken: authToken?.refreshToken,
                            }
                        )
                        const { data: accessToken } = tokenResponse
                        const getEndeavorUserToken = {
                            authorisationToken: accessToken.authorisationToken,
                            refreshToken: authToken.refreshToken,
                        }
                        localStorage.setItem(
                            AUTH_TOKEN.ENDEAVOR_AUTH_TOKEN,
                            JSON.stringify(getEndeavorUserToken)
                        )
                        Axios.setEndeavorAuthToken(getEndeavorUserToken)
                        return axiosInstance(originalConfig)
                    } catch (_error) {
                        window.location.href = ROUTES.LOGIN
                        localStorage.removeItem(AUTH_TOKEN.ENDEAVOR_AUTH_TOKEN)
                        localStorage.removeItem(
                            AUTHENTICATED_USER.IS_LOGIN_USER
                        )
                        localStorage.removeItem(GUEST_USER.IS_GUEST_USER)
                        localStorage.removeItem(USER_ONBOARDING_STATUS)
                        return Promise.reject(_error)
                    }
                }
            }

            return Promise.reject(err)
        }
    }
)

export default axiosInstance
